export default function MediaSection() {
  const mediaItems = [
    {
      id: 1,
      title: '《星辰变》第六季PV',
      desc: '秦羽神界冒险震撼预告，全新场景设计首次曝光，画面品质全面升级。',
      duration: '03:25',
      tag: '预告片',
      image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20trailer%20scene%20with%20glowing%20divine%20realm%2C%20a%20warrior%20with%20flaming%20wings%2C%20dramatic%20golden%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20amber%20tones%2C%20anime%20art%20style&width=800&height=500&seq=media-1-anime&orientation=landscape',
    },
    {
      id: 2,
      title: '国漫精彩战斗混剪',
      desc: '精选本年度国产动画最燃战斗场景，热血与感动的完美剪辑。',
      duration: '08:12',
      tag: '混剪',
      image: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20battle%20montage%20scene%20with%20explosive%20energy%20effects%2C%20multiple%20fighters%2C%20intense%20action%2C%20warm%20fire%20lighting%2C%20dramatic%20composition%2C%20vibrant%20red%20and%20orange%20colors%2C%20anime%20style&width=800&height=500&seq=media-2-anime&orientation=landscape',
    },
    {
      id: 3,
      title: '《一念永恒》声优专访',
      desc: '白小纯配音演员独家访谈，分享角色演绎背后的有趣故事与创作心得。',
      duration: '15:40',
      tag: '专访',
      image: 'https://readdy.ai/api/search-image?query=Anime%20voice%20actor%20interview%20style%20scene%20with%20microphone%20and%20character%20illustration%20in%20background%2C%20warm%20studio%20lighting%2C%20professional%20setup%2C%20soft%20orange%20and%20amber%20tones%2C%20clean%20composition&width=800&height=500&seq=media-3-anime&orientation=landscape',
    },
    {
      id: 4,
      title: '2026国产动画年度盘点',
      desc: '回顾本年度国产动画行业大事记，从技术突破到市场表现全面解读。',
      duration: '22:08',
      tag: '盘点',
      image: 'https://readdy.ai/api/search-image?query=Year-end%20anime%20review%20style%20scene%20with%20collage%20of%20various%20anime%20characters%2C%20festive%20warm%20lighting%2C%20celebration%20atmosphere%2C%20rich%20red%20and%20gold%20colors%2C%20cinematic%20composition%2C%20anime%20art%20style&width=800&height=500&seq=media-4-anime&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            动漫精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            51动漫精选预告片、混剪与专题视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[180px] md:h-[200px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`51动漫 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-2xl md:text-3xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-black/60 text-background-50 text-xs rounded-md">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}